import { Field } from 'devextreme/ui/pivot_grid/data_source';

export const tetelek_group: Field = {
  caption: 'tetelek',
  groupName: 'tetelek',
  isMeasure: false,
};

export const termekek_group: Field = {
  caption: 'termekek',
  groupName: 'termekek',
  isMeasure: false,
};

export const adat_tipus_group: Field = {
  caption: 'adat_tipus',
  groupName: 'adat_tipus',
  isMeasure: false,
};

export const regiok_es_varmegyek_group: Field = {
  caption: 'regiok_es_varmegyek',
  groupName: 'regiok_es_varmegyek',
  isMeasure: false,
};

export const keszletek_group: Field = {
  caption: 'keszletek',
  groupName: 'keszletek',
  isMeasure: false,
};

export const engedelyes_group: Field = {
  caption: 'engedelyes',
  groupName: 'engedelyes',
  isMeasure: false,
};


export const felhasznalasi_cel_group: Field = {
  caption: 'felhasznalasi_cel',
  groupName: 'felhasznalasi_cel',
  isMeasure: false,
};

export const fogyasztasi_sav_group: Field = {
  caption: 'fogyasztasi_sav',
  groupName: 'fogyasztasi_sav',
  isMeasure: false,
};

export const adozasi_szint_group: Field = {
  caption: 'adozasi_szint',
  groupName: 'adozasi_szint',
  isMeasure: false,
};

export const tevekenyseg_group: Field = {
  caption: 'tevekenyseg',
  groupName: 'tevekenyseg',
  isMeasure: false,
};

export const orszag_group: Field = {
  caption: 'orszag',
  groupName: 'orszag',
  isMeasure: false,
};

